export default {
  ActionConfirm: "Подтвердите действие",
  ActivatePromocode: "Активировать промокод",
  AddFile: "Добавить файл",
  AddToFavorites: "Добавить в избранное",
  "Andar Bahar": "Andar Bahar",
  ApplyFilter: "Применить фильтр",
  AppsPage: {
    blocks: {
      descriptionOne: "Не нужно искать актуальные зеркала",
      descriptionThree: "Персональные уведомления о всех акциях, турнирах и розыгрышах",
      descriptionTwo: "Уникальные акции и предложения для пользователей приложений",
      titleOne: "ОЛИМП всегда под рукой",
      titleThree: "Будьте в курсе всех событий и предложений",
      titleTwo: "Эксклюзивные акции и турниры"
    },
    dontWorry: "Не переживайте, это безопасно",
    howToInstall: "Как установить",
    installAndroid: "Скачать для Андроид",
    installIos: "Установить для iOS",
    installIsSafe: "Установка безопасна",
    qrText: "Наведите камеру на QR-код, чтобы скачать приложение",
    safeDescription: " Мы не можем выложить приложение в Play Market из-за политики Google в отношении азартных игр. Для установки, следуйте инструкции",
    seo: {
      all: {
        block_one: {
          description: "{platform} — это современная платформа для виртуального беттинга и гемблинга с большим ассортиментом развлечений. Мы уделяем особое внимание комфорту пользователей, именно поэтому нашу онлайн-площадку можно посетить с любого устройства — как с компьютера, так и со смартфона. Мобильное приложение казино Олимп адаптировано для всех современных телефонов, которые работают на базе популярных операционных систем — Android и iOS. Любители азартных игр могут использовать весь потенциал интернет платформы где угодно в удобное для них время.",
          title: "Мобильное приложение {platform}"
        },
        block_three: {
          description: "В распоряжении любого игрока, который скачал приложение и зарегистрировался в нём, — весь функционал площадки и полный набор инструментов. Что именно доступно в мобильном приложении? Через личный кабинет вы можете:",
          list: {
            five: "Изучать историю финансовых операций по игровому счёту — заказов на снятие средств, платежей и ставок.",
            four: "Использовать бонусы — welcome-пакет и другие подарки.",
            one: "Настраивать профиль — добавить номер телефона или адрес почты, заполнить информацию о себе и изменить её.",
            three: "Следить за рассылкой от казино в сообщениях.",
            two: "Проверять баланс, пополнять его любыми удобными способами, выводить призовые суммы и получать моментальный кешбэк."
          },
          text: "Играть онлайн в казино Олимп и делать ставки можно сразу после процедуры регистрации. Нужно лишь внести минимальный депозит и выбрать развлечение по душе — в нашем приложении представлены игровые автоматы, лотереи, быстрые, спортивные и классические игры, live-казино, ставки на спорт и различные турниры. Если у вас возникнут вопросы во время онлайн-сессии в приложении Olymp Casino, на помощь придёт техническая поддержка. Достаточно открыть чат и оставить сообщение в специальной форме.",
          title: "Функционал"
        },
        block_two: {
          description: "Магазины приложений — Google Play Market, AppGallery и другие маркеты — придерживаются разной политики в отношении азартных развлечений и не всегда размещают в своих каталогах необходимый софт. Мы упростили вам процесс поисков и разместили мобильное приложение казино Олимп для всех ОС в открытом доступе — его легко скачать прямо с нашего официального сайта. Можно выбрать один из следующих алгоритмов действия:",
          list: {
            one: "Воспользоваться компьютером. Для этого запустите официальный портал {platform} через любой браузер или откройте через поисковую систему рабочее зеркало. Там вы найдёте страницу с кнопками «Установить для iOS»  и «Скачать для Андроид». Кликните на подходящий вариант и отсканируйте QR-код с помощью камеры телефона. На его экране отобразится ссылка — перейдите по ней. Если вы используете iPhone, вас перенаправит на наше приложение в App Store, откуда вы сможете его загрузить. Если у вас Android, нужно предоставить разрешение на установку приложения и дождаться её окончания.",
            two: " Воспользоваться мобильными устройствами. Зайдите на сайт {platformSite} — откроется мобильная версия сайта Олимп. Чтобы скачать приложение бесплатно, сначала выберете из двух кнопок для загрузки нужную в зависимости от ОС вашего смартфона. Не забудьте сперва заглянуть в «Настройки» телефона и разрешить установку неизвестных файлов — это безопасно. Приложение скачается за считанные минуты"
          },
          text: "Жмите «Вход» и приступайте к авторизации. Если вы ещё не обзавелись аккаунтом в {platform}, самое время это сделать. Введите в соответствующие поля номер телефона или e-mail, придумайте хороший пароль и подтвердите действие.",
          title: "Где скачать приложение"
        }
      },
      android: {
        block_four: {
          description: "Мобильное приложение {platform} работает на английском, казахском, узбекском, кыргызском и русском языке — можно сменить его в любой момент. Приложение адаптировано для использования через телефон с максимальным комфортом — все элементы интерфейса перенесены сюда с учётом размеров мобильных экранов. Каждому авторизованному владельцу смартфона доступны все функции десктопной версии сайта:",
          list: {
            five: "Личные сообщения.",
            four: "История платежей, ставок и заказов на вывод средств.",
            one: "Настройки профиля.",
            three: "Промокоды и подарки — фриспины, бесплатные ставки и бонусы на депозит.",
            two: "Операции с игровым счётом — пополнение, вывод и моментальный кешбэк."
          },
          text: "И главное — через телефон или планшет вы сможете опробовать любые игры, которые вас заинтересовали, испытать удачу в ставках на спорт и поучаствовать в акциях и турнирах. Казино Олимп всегда будет у вас под рукой, а благодаря персональным уведомлениям вы не пропустите эксклюзивные предложения.",
          title: "Функционал"
        },
        block_one: {
          description: "В {platform} собрана богатая коллекция азартных развлечений для всех, кто предпочитает отдыхать с удовольствием независимо от места нахождения. Ставки на спорт и лотереи, быстрые и бет игры, live-казино и слоты — игровой софт доступен вам прямо с телефона! Владельцы смартфонов на базе операционной системы Андроид могут позволить себе всё — специально для вас мы разработали специальное мобильное приложение Олимп на Андроид. Пополняйте личный счёт через телефон или планшет, запускайте онлайн любимые игровые автоматы и слоты и наслаждайтесь процессом.",
          title: "Приложение для Android Олимп Казино"
        },
        block_three: {
          description: "Собираетесь скачать бесплатно приложение Олимп на Android с официального сайта? Нужно подготовить мобильное устройство к установке APK-файлов. Для начала включите необходимые разрешения:",
          list: {
            four: "При появлении на экране запроса «Разрешить установку из этого источника» нажмите кнопку, чтобы начать скачивание.",
            one: "Перейдите к «Настройкам» на смартфоне и найдите пункт «Приложения».",
            three: "Обеспечьте доступ для установки неизвестных приложений.",
            two: "Откройте меню «Разрешения»."
          },
          text: "Скачать приложение Олимп на Андроид через десктопную версию портала можно с помощью QR-кода. Он появится прямо на странице — вам останется только навести камеру смартфона на код и дождаться ссылки для загрузки. С мобильной версией Olymp Casino процесс установки сводится к нескольким простым действиям. Чтобы загрузить приложение через смартфон, откройте в браузере мобильную версию портала. Там вы увидите кнопку «Скачать приложение». Перейдите по ней — и перед вами появится надпись «Загрузить». Смело жмите на ссылки для установки — это безопасно, файл скачается из надёжного источника. Готово! Можно наслаждаться всеми преимуществами мобильного приложения. Теперь вы избавлены от необходимости искать рабочие зеркала или устанавливать VPN — мобильное приложение Olymp Casino будет работать, пока у вас есть выход в Интернет. Если данное приложение потребует обновления до последней версии, сделайте это, чтобы всё работало исправно.",
          title: "Инструкция по установке"
        },
        block_two: {
          description: "Мобильное приложение {platform} для Android — ваш проводник в мир лучших азартных игр и спортивных ставок. Где его скачать? В мобильных маркетах для Андроид — например, в Google Play Market, AppGallery или любом другом похожем магазине приложений — действуют особая политика в отношении азартных игр. Там можно встретить только проекты от сторонних разработчиков. С официальным сайтом Olymp Casino они никак не связаны. Чтобы найти наше оригинальное приложение, нужно открыть главный сайт olymp.casino на компьютере или на мобильном устройстве.",
          title: "Где скачать приложение"
        }
      },
      ios: {
        block_one: {
          description: "Среди владельцев iPhone и iPad много поклонников азартных игр {platform}. Наше мобильное приложение для устройств на базе операционной системы iOS открывает перед пользователями широкие возможности и предоставляет полную свободу действий. В любое время у вас в кармане — огромный каталог развлечений с полным функционалом интернет-казино. Вносите средства на счёт, управляйте данными профиля, обналичивайте призовые суммы любых размеров, играйте в режиме онлайн и пробуйте новое каждый день. Мобильное приложение казино Олимп для iOS поможет вам получить столько удовольствия и извлечь столько выгоды, сколько вы сами хотите! Для этого нужно правильно «оснастить» свой телефон или планшет и перейти к развлечениям.",
          title: "iOS приложение Олимп Казино для iPhone"
        },
        block_three: {
          description: "Приложение казино Олимп для устройств на базе iOS открывает вам полный доступ ко всей коллекции азартных развлечений платформы — многочисленным слотам, настольным, спортивным и краш-играм, столам, лотереям, акциям, турнирам. Через личный кабинет в мобильном приложении можно выполнить любые необходимые действия:",
          list: {
            five: "Просмотреть историю операций — всех заказов на вывод денег, транзакций и ставок.",
            four: "Прочитать сообщения от казино.",
            one: "Изменить персональные сведения в профиле и пройти верификацию.",
            three: "Получить, активировать и отыграть подарки — в том числе welcome-бонус для новичков.",
            two: "Пополнить счёт, обналичить выигрыш и получить моментальный кешбэк."
          },
          text: "Специально для пользователей мобильного приложения предусмотрено множество уникальных предложений: не забудьте включить уведомления, чтобы оставаться в курсе всех событий и своевременно узнавать о выгодных акциях, актуальных розыгрышах и эксклюзивных турнирах. Пора пополнять депозит, делать ставки, «тестировать» игровые автоматы и прокачивать удачу. Мы позаботились о том, чтобы каждая виртуальная сессия в приложении казино Olymp доставляла вам только приятные впечатления.",
          title: "Функционал и возможности"
        },
        block_two: {
          description: "  Мы знаем, как эффективно и с комфортом для пользователей обеспечить их необходимым инструментом для игры. Мобильное приложение {platform} есть в фирменном магазине Apple — оно бесплатное. Чтобы загрузить официальное приложение Олимп для iOS, нужно получить ссылку на его скачивание из магазина App Store. Есть два способа это сделать – выбрать можно тот, что удобнее:",
          list: {
            one: "Запустите официальный сайт казино Олимп на компьютере и перейдите на страницу со ссылкой на мобильное приложение. Там вы увидите QR-код — наведите на него камеру вашего устройства и нажмите на ссылку для скачивания.",
            two: "Зайдите на портал {platformSite} сразу через устройство на платформе iOS —откроется мобильная версия. Чтобы скачать приложение Олимп на iPhone или iPad таким образом, достаточно нажать на кнопку «Установить для iOS». Вас перенаправит в App Store — и вы сможете начать установку приложения."
          },
          text: "Когда скачивание завершится, можно создать аккаунт в системе или авторизоваться, если у вас уже есть личный кабинет, и приступить к самому интересному — развлечениям {platform}!",
          title: "Установить приложение легко"
        }
      }
    },
    seoText: " Особый сеошный текст может и не понадобится на странице для айфонов, но можно попробовать написать обзор на приложение и оптимизироваться под семантику категории “обзор приложения олимпбет”. И там и там почти нет частотки.",
    seoTitle: "SEO text",
    slider: {
      textEight: "Нажмите на кнопку «Скачать приложение» на сайте",
      textFive: "Нажмите на кнопку «Установить»",
      textFour: "Нажмите на скачанный файл приложения",
      textOne: "Нажмите на кнопку «Загрузить», чтобы начать скачивание",
      textSeven: "Наведите камеру телефона на QR код и перейдите на сайт",
      textSix: "Запускаете приложение с рабочего стола и играете",
      textThree: "Разрешите установку приложений из неизвестных источников",
      textTwo: "Зайдите в раздел «Установка неизвестных приложений»"
    },
    slides: {
      allowInstall: "Разрешить установку из неизвестных источников",
      cancel: "Отмена",
      download: "Загрузить",
      downloadApp: "Скачать Приложение",
      downloadIsDone: "Загрузка завершена",
      installUnknownApp: "Установка неизвестных приложений",
      isntall: "Установить",
      moveToSite: "Перейти на сайт",
      myFiles: "Мои файлы",
      safeDescription: " Установка приложений не из Play Market. Загружайте файл только из надежного источника",
      settings: "Настройки"
    },
    textForMobile: {
      androidAndIos: "на Андроид и iOS",
      downloadOnAndroid: "Скачать на Андроид",
      downloadOnAndroidAndIos: "Скачать на Андроид и iOS",
      downloadOnIos: "Скачать на iOS",
      onAndroid: "на Андроид",
      onIos: "на iOS"
    },
    title: "Приложение Олимп"
  },
  Aviator: "Aviator",
  Basket: "Корзина",
  BeforeEndPromotion: "До окончания акции",
  BeforeStartPromotion: "До начала акции",
  Betgames: "Betgames",
  Bets: "Cтавки",
  BonusBalanceOff: "Вы переключились на основной баланс казино. Пополните счет и играйте в любимые игры.",
  BonusBalanceOn: "Вы переключились на бонусный баланс.",
  BonusesAndPromotions: "Бонусы и акции",
  BonusesAndPromotionsSection: "Раздел бонусов и акций",
  Categories: "Категории",
  Chat: "Чат",
  CloseMatchTracker: "Закрыть матч-трекер",
  CoefficientChanged: "Изменился коэффициент",
  ContactSupport: "Обратитесь в поддержку",
  "Cricket X": "Cricket X",
  DeleteConfirm: "Подтверждение удаления",
  DeleteConfirmText: "Вы действительно хотите удалить ранее загруженные файлы?",
  DeleteFiles: "Удалить файлы",
  DenyReason: "Отклонено по причине",
  DocumentAlreadyAttached: "Данный файл уже прикреплен",
  DocumentDoesntMeetRequirements: "Документ не соответствует требованиям",
  DocumentResolutionTooBig: "Слишком большое разрешение фотографии. Максимально допустимое - {value} Мп",
  DocumentsFilesLimits: "(макс. кол-во файлов - {fields}, макс. размер файла - {size} Мб)",
  DocumentsUploadError: "Произошла ошибка во время загрузки файлов - {files}. Остальные файлы были отправлены на проверку. Вы можете попробовать загрузить эти файлы повторно",
  DownloadOn: "Скачать на",
  EuroLanding: {
    activate: "<span>Активируйте</span><br /> в разделе «Бонусы»",
    bonusText: "<span>Фрибет</span><b>{freebet}</b><span>за регистрацию!</span>",
    register: "<span>Регистрируйтесь</span><br /> на сайте Olymp Casino"
  },
  Event: "Событие",
  Exclusive: "Эксклюзивные",
  Expires: "Истекает",
  ForbidenBonus: "Призы за текущий день уже были получены",
  Found: "Найдено",
  FruityWheel: {
    btn: "Крути",
    title: "Крути и узнай свой welcome бонус"
  },
  GatesOfOlympus: {
    completeSignIn: "Завершите регистрацию сейчас и получите бонус",
    getBonus: "Забрать бонус",
    spin: "Крути",
    titleFirstLine: "Крути колесо",
    titleSecondLine: "получай бонусы",
    twist: "Крутить",
    youWin: "Вы выиграли",
    yourBonus: "Ваш бонус"
  },
  GetYourPrizes: "Забирай призы",
  GoldenTimesKz: {
    bonusText: "Поздравляем! Твой выигрыш",
    headTitle: "Забирай свой бонус<br />и срывай джекпот!",
    labelText: "Введите номер своего телефона"
  },
  InformationAllPromotions: "Информация по всем акциям",
  InitialCoefficient: "Исходный коэф.:",
  JetX: "JetX",
  LongTermRates: "Долгосрочные ставки",
  MainSite: "Основной сайт",
  MatchTracker: "Матч-трекер",
  MaximizeMatchTracker: "Увеличить матч-трекер",
  MinimizeMatchTracker: "Уменьшить матч-трекер",
  Mobile: "Мобильная",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "Выберите пункт меню /app",
    getLink: "или получи ссылку в Telegram боте",
    getLinkButton: "Получить ссылку",
    groups: {
      four: "Будьте в курсе всех <br/> событий и предложений",
      one: "<span>100 FS без депозита</span>за установку приложения",
      three: "Эксклюзивные <br/> акции и турниры",
      two: "Не нужно искать <br/> актуальные зеркала"
    },
    start: "/start",
    startText: "Запустите Telegram бота нажав /start",
    successLink: "Ссылка успешно отправлена",
    text: "Скачивай мобильное приложение Olymp и будь готов к игре в любой момент",
    title: "<span>100 FS без <br/> депозита </span> за установку OLYMP"
  },
  MobileApplications: "Мобильные приложения",
  MyDocuments: "Мои документы",
  NewYearRules: {
    "1": "Период проведения акции: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Фрибеты Aviator",
    "11": "Фрибеты JetX",
    "12": "В случае выигрыша бонуса на промо странице, бонус добавляется в личный кабинет, раздел “Бонусы”, путем нажатия на кнопку “Перейти к бонусу”",
    "13": "Активация добавленных бонусов доступна в течение 3 дней",
    "14": "После активации депозит необходимо внести в течение 1 дня",
    "15": "Отыгрыш бонусных средств необходимо совершить в течение 1 дня",
    "16": "Подробные условия по каждому бонусу доступны на странице “Бонусы” в личном кабинете",
    "2": "Каждый день на промо странице дается 3 попытки для получения бонуса",
    "3": "Количество попыток обнуляются до 3 каждый день в течение срока действия акции в 00:00 GMT +5",
    "4": "Чтобы выиграть бонус, пользователь должен заходить каждый день на промо страницу и запускать слотмашину путем нажатия на кнопку SPIN",
    "5": "Каждое нажатие на SPIN забирает одну попытку",
    "6": "Выигрыш бонуса и тип бонуса определяется случайным образом из:",
    "7": "Бонус на депозит в слотах",
    "8": "Фриспины в слотах",
    "9": "Фрибеты на спорт"
  },
  NezlobLanding: {
    forDeposit: "на депозит",
    title: "Шутки кончились!"
  },
  NotCalculated: "Не рассчитано",
  NotSingleActionCurrentlyHeld: "Ни одной акции сейчас не проводится",
  OlimpCasino: "Олимп казино",
  OpenFullVersion: "Открыть полную версию",
  PaymentMethods: "Способы оплаты",
  PlayEveryDay: "Играй каждый день",
  PromoAvailableFrom: "Акция доступна с {date} года",
  PromoAvailableFromTo: "Акция доступна с {date1} до {date2} года",
  PromoEnded: "Акция завершена {date} года",
  Promotions: "Акции",
  PromotionsWillDisplayedHere: "Здесь будут отображаться акции",
  QuestionAndAnswer: "Вопрос - Ответ",
  RulesAcceptingBets: "Правила приема ставок Букмекерской конторы «ОЛИМП»",
  RulesOfPromotion: "Правила акции",
  RulesSingle: "Правила",
  SelectTypeSystem: "Выберите тип системы",
  Soon: "Скоро",
  Statistics: "Статистика",
  StayTuned: "Оставайтесь с нами",
  TableContents: "Оглавление",
  TheSearchHasNotGivenAnyResults: "Поиск не дал результатов",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "Для отключения необходимо подтвердить телефон и e-mail",
  ToMain: "На главную",
  ToUp: "Наверх",
  TypeBonusesAndPromotions: "Тип бонусов и акций",
  UntilTheNextBonus: "До следующего бонуса",
  UploadDocuments: "Загруженные файлы",
  Version: "версия",
  WeAreOnSocialMedia: "Мы в соц. сетях",
  WeOnSocialMediaFull: "Мы в социальных сетях",
  WorldCup: "ЧМ-2022",
  YouDataProtected: "Личные данные и средства в безопасности",
  YourBonus: "Ваш бонус",
  aboutBonus: "Подробнее о бонусе",
  acceptWithModifiedOdds: "Принимать с изменёнными коэффициентами",
  acceptWithModifiedTotals: "Принимать с измененными тоталами/форами",
  accountApprove: "Аккаунт защищен",
  accountNotApprove: "Аккаунт не защищен",
  action: "Действие",
  activate: "Активировать",
  activateBonus: "Активировать бонус",
  activateFastBets: "Активируйте быстрые ставки",
  activatingPromoCode: "Активация промокода",
  active: "Активный",
  activeBonusErr: "Для активации бонуса, осталось совершить депозит на сумму не менее",
  activeWager: "Активный вейджер",
  add: "Добавить",
  addToBasket: "Добавить в корзину",
  addYourFavoriteGames: "Добавляйте любимые игры в избранное с помощью",
  addingDogeCoin: "Добавляем монету Doge",
  additionalInfo: "Дополнительная информация",
  addressCryptoWallet: "Адрес криптокошелька",
  addressWallet: "Адрес кошелька",
  afterInstallApp: "Вы получили бонус {0} за установку приложения",
  agreeTermsAndConditions: "Я согласен с {0} и подтверждаю, что мне больше 18 лет",
  all: "Все",
  allDepositMethods: "Все методы пополнения",
  allGames: "Все игры",
  allMessages: "Всего",
  allMessagesButton: "Перейти в сообщения",
  allMessagesText: "Все сообщения",
  allPromo: "Все акции",
  allRequiredFieldsMustBeFilled: "Все обязательные поля должны быть заполнены",
  allTypes: "Все типы",
  allWithdrawMethods: "Все методы вывода",
  all_right: "Все права защищены.",
  alreadyHasAccount: "Уже есть аккаунт",
  always: "Всегда",
  amountOnAccount: "Сумма на счету",
  anUnexpectedErrorOccurred: "Произошла непредвиденная ошибка!",
  antifraud: {
    five: "Многоступенчатая проверка клиентов (Проверка по IP, снятие параметров системы, прокси проверка); Проверка телефонного номера клиента; Анализ поведения игрока специалистом; Система защиты от мошенничества имеет более чем 100 фильтров, предназначенных для глубокой проверки платежных данных, истории платежей и черного списка пользователей; Клиент проходит окончательную проверку нашей контрольной службой на этапе вывода средств.",
    four: "Основные характеристики",
    one: "Защита от мошенничества",
    three: "В сотрудничестве с ведущими поставщиками услуг интернет-платежей, мы делаем все возможное, чтобы вести онлайн бизнес надежно и гарантировать безопасность приватной информации наших пользователей, а так же всех платежных данных. Наш десятилетний опыт управления базами данных платежных транзакций, делает Avento AntiFraud Tool действительно мощным и удобным средство против мошенничества с кредитными картами.",
    two: "Avento AntiFraud Tool является мощным инструментом для защиты от мошенничества, разработанным, чтобы предотвратить мошеннические операции в онлайн-сфере азартных игр. Что позволяет нам значительно понизить количество мошенничества с кредитными картами в наших игорных заведениях."
  },
  app: "Приложение",
  appOlymp: "Приложение Олимп",
  apply: "Применить",
  approve: "Подтверждаю",
  approvePhoneBySms: "Подтвердить номер по СМС",
  approvePhoneByTelegram: "Подтвердить номер через Telegram",
  approved: "Одобрено",
  approvedSecond: "Подтверждено",
  approvingWithdraw: "Подтверждение вывода средств",
  april: "апреля",
  areYouSureDeposit: "Вы точно пополнили?",
  areYouSureToDeclineBonus: "Вы уверены что хотите отказаться от бонуса?",
  areYouSureYouWantToSell: "Вы уверены что хотите продать ставку",
  attach: "Прикрепить документы",
  attachDocumentsToVerifyAccount: "Пожалуйста, прикрепите документы для завершения верификации и для вывода средств",
  attempt: "Нет попыток | 1 Попытка | {count} Попытки",
  august: "августа",
  authApproveText: "Для проверки, что вы не робот, нажмите на кнопку 'Подтверждаю'",
  authFromSocial: "Вход через соц. сети",
  authorization: "Авторизация",
  authorizationRequired: "Платная игра требует авторизации!",
  availabilityWallet: "Необходим криптокошелек {wallet}",
  available: "Доступно",
  availableBonuses: "Доступные бонусы",
  availableOnlyGameForMoney: "Доступна только игра на деньги",
  back: "Назад",
  backToHome: "Вернуться на главную",
  backToLogin: "Вернуться к авторизации",
  backToOneStep: "Вернуться на первый шаг",
  balance: "Баланс",
  balanceAfterTopUp: "Баланс после пополнения: {value}",
  balanceAfterWithdraw: "Баланс после вывода: {value}",
  balanceBK: "Баланс БК",
  balanceBKRefreshSuccessfully: "Баланс БК успешно обновлен",
  balanceCasino: "Баланс казино",
  balanceCasinoRefreshSuccessfully: "Баланс казино успешно обновлен",
  balanceSwitchByWithoutBalance: "Переключение на бонусный баланс происходит автоматически только при игре в бонусные игры, если на реальном балансе отсутствуют средства",
  balances: "Балансы",
  bankCard: "Банковская карта",
  basketBets: "Корзина",
  behind: "за",
  bet: "Ставка",
  betHistory: "Ставки",
  betID: "ID ставки",
  betSoldFor: "Ставка продана за {count}",
  betsAreSuspended: "Прием ставок приостановлен",
  betsNotAccessForBonusBalance: "Ставки на спорт не доступны с бонусного баланса!",
  bettingHistory: {
    bet: "Ставка",
    coefficient: "Коэффициент",
    dataOfBet: "Данные ставки",
    findOutTheScore: "Узнать счёт",
    numberAndDateOfBet: "Номер и дата ставки",
    payout: "Выплата",
    status: "Статус"
  },
  bidAddedToCart: "Ставка добавлена в корзину",
  bidDeletedToCart: "Ставка удалена из корзины",
  bonus: "Бонус",
  bonusActivated: "Бонус активирован",
  bonusActivation: "Активация бонуса",
  bonusBalance: "Бонус. баланс",
  bonusBalanceOnly: "Для игры с бонусного баланса запустите бонусную игру",
  bonusCondition: "Условия бонуса",
  bonusNotActivated: "Бонус не активирован",
  bonusOnFirstDeposit: "Бонус 100 %<br/> на первый депозит",
  bonusQuestion: "Вы еще не получили приветственный бонус?",
  bonusSport: {
    block1: {
      li1: "Зарегистрируйтесь на сайте olymp.casino.",
      li2: "Для активации бонуса перейдите в раздел «Бонусы» в Личном кабинете и активируйте предложение.",
      li3: "Внесите депозит от 500 KZT / 12 000 UZS одним платежом.",
      li4: "После пополнения бонус будет начислен автоматически и доступен для ставки в разделе «Спорт» в вашем купоне.",
      title: "Как получить свой бонус:"
    },
    block2: {
      li1: "Пользователь имеет право только на один бонус.",
      li2: "Бесплатную ставку можно использовать только на спорт. Ваш купон должен быть ординарной ставкой с коэффициентом не менее 3 и максимум 10.",
      li3: "Игрок получает на свой счет только выигрышную часть.",
      text: "Например: Бесплатная ставка 500 на коэффициент 3. Игрок получает на счет 3*500-500 = 1000.",
      title: "Условия и положения:"
    },
    block3: {
      li1: "Требования по отыгрышу бесплатной ставки должны быть выполнены в течение 7 дней, в противном случае срок действия бонуса истечет.",
      li10: "Olymp.casino имеет право изменить условия предложения, отменить или возобновить предложение, либо отказать в участии в любое время без предварительного уведомления.",
      li11: "Olymp.casino может ограничить или отказать пользователям в участии в этом или любом другом предложении.",
      li12: "Для одного клиента, семьи, адреса, общего компьютера, общего IP-адреса и любых идентичных данных учетной записи, включая адрес электронной почты,  реквизиты банковского счета, информацию о кредитной карте и счете платежной системы, допускается только один бонус. Любое злоупотребление этим бонусным предложением приведет к закрытию счета.",
      li13: "Olymp.casino оcтавляет за собой право в любое время изменить или отменить данное предложение.",
      li14: "Принимая бонус, клиент соглашается с бонусными условиями, а также с общими правилами и положениями Olymp.casino.",
      li2: "Для вывода выигрыша вам необходимо сделать минимальный депозит 500 KZT / 12 000 UZS и выполнить вейджер х1.",
      li3: "В случае отмены или возврата - ставка рассчитывается как проигрыш.",
      li4: "В случае полупроигрыш (азиатская фора и тотал) - ставка рассчитывается как проигрыш.",
      li5: "В случае полувыигрыш (азиатская фора и тотал) - рассчитывается как обычная ставка, исключая сумму ставки.",
      li6: "После расчета ставки деньги поступают на ваш баланс.",
      li7: "Бесплатная ставка не может быть использована частично. (т. е. если у вас есть бесплатная ставка на 500, вы должны сделать ставку на 500. 250 - 250 для разных купонов не принимаются).",
      li8: "Предложение не может быть использовано в сочетании с другими рекламными или специальными предложениями.",
      li9: "Использование нескольких учетных записей не допускается и в случае обнаружения нескольких учетных записей это приведет к приостановке всей учетной записи.",
      title: "Другие условия:"
    },
    title: "Лучшее время присоединиться к Olymp.Casino - сейчас, ведь мы предлагаем каждому новому пользователю бесплатную ставку на спорт 500 KZT / 12 000 UZS."
  },
  bonusTimeLeft: "Время для выполнения действия",
  bonusWager: "Вейджер бонуса:",
  bonuses: "Бонусы",
  bookmakerShort: "БК",
  "break": "Перерыв",
  bronze: "Бронза",
  btn: "Касса",
  byDefault: "По умолчанию",
  byDefaultDown: "По алфавиту (A-Z)",
  byDefaultUp: "По алфавиту (Z-A)",
  bySport: "По видам спорта",
  cabbage: {
    eight: "- если игрок завершил полный цикл из 5 дней.",
    eighteen: "Приз {number}",
    eleven: "Принимая участие в акции, вы автоматически соглашаетесь с этими правилами и условиями, установленными онлайн-казино, проводящим эту акцию.",
    fifteen: "Цели и призы",
    five: "Награды растут вместе с ежедневным прогрессом и выполнением дневных целей. Чтобы сохранить ежедневный прогресс, иметь возможность перейти в следующий день цикла и претендовать на более крупные награды, участнику необходимо выполнить ежедневную цель хотя бы один раз.",
    four: "Кампания «Ежедневные призы» проходит в циклах продолжительностью до 5 календарных дней каждый с возможностью выполнить ежедневную цель до 3 раз.",
    fourteen: "В случае сбоев все выигрыши аннулируются.",
    list: "Правила и условия:",
    nine: "Для участия в акции не требуется совершать дополнительных депозитов или делать взносов.",
    nineteen: "Ежеднев. цель выполнена 1 раз",
    one: "Пора собирать урожай капусты высшего сорта в денежном эквиваленте!",
    seven: "- если игрок пропустил день или не выполнил ежедневную цель хотя бы один раз;",
    seventeen: "Ежеднев. цели",
    six: "Цикл ежедневных наград участника сбрасывается до первого дня в 2-х случаях:",
    sixteen: "День в цикле",
    ten: "Принять участие в акции возможно только играя за реальные деньги.",
    thirteen: "{company} оставляет право в любое время прекратить акцию на неопределенный срок без выплаты призов, а также изменять правила без предварительного уведомления.",
    three: "Для участия необходимо сыграть в любую из игр провайдера Booongo. Призовой фонд - до 1160 евро на участвующего. Сумма рассчитывается как максимальный общий личный призовой фонд, если участник выполнил все возможные ежедневные цели на протяжении всей кампании (2 полных цикла). Самая сочная награда будет в последний день каждого цикла!",
    twelve: "Правила и условия участия могут быть изменены в любое время исключительно на усмотрение {company}.",
    twenty: "Ежеднев. цель выполнена 2 раза",
    twentyFive: "до 1160 евро на участвующего!",
    twentyFour: "Призовой фонд",
    twentyOne: "Ежеднев. цель выполнена 3 раза",
    twentySix: "Дата и время",
    two: "Чтобы принять участие, сыграйте в любую из игр провайдера Booongo и достигайте ежедневных целей."
  },
  cabinet: "Личный кабинет",
  calculated: "Рассчитанные",
  calculationID: "ID расчета",
  canNotChangeCurrency: "Нельзя изменить валюту",
  canSelectSavedData: "Можете выбрать сохраненные данные",
  cancel: "Отмена",
  cancelBonus: "Отменить бонус",
  cancelBonusConfirm: "Вы уверены, что хотите отменить бонус? При отмене все бонусные средства будут аннулированы",
  cantEnterTheCode: "Не получается ввести код?",
  carriedOut: "Выполнено",
  cashBackSum: "Сумма моментального Cashback",
  cashBoxApproveCode: "Код подтверждения",
  cashBoxApproveCodeHint: "Потребуется кассиру для подтверждения вывода",
  cashBoxDeliveryText: "Для вашего удобства при сумме пополнения/вывода средств от {0} к вам может приехать курьер. Чтобы вызвать курьера, напишите нам в телеграм, логин {1}",
  cashbackTitle: "Cashback",
  cashboxAddress: "Адрес кассы",
  casino: "Казино",
  casinoBonus: "Бонус казино",
  casinoLogin: "{name}-логин",
  categoryFromAtoZ: "Категория от А до Я",
  change: "Изменить",
  changeData: "Изменить данные",
  changeEmail: "Изменить почту",
  changeMethod: "Изменить метод",
  changePassword: "Изменить пароль",
  changePhone: "Изменить номер",
  changeStatusCode: "Сменить статус кода",
  changeTheEmail: "Изменить email",
  changeWallet: "Изменить кошелек",
  changingEmail: "Изменение e-mail",
  changingPhone: "Изменение номера",
  checkRobotText: "Для проверки что вы не робот, нажмите на кнопку \"Подтверждаю\"",
  checking: "На проверке",
  chooseComfortableAddress: "Выберите удобный для посещения адрес",
  chooseDepositViaCryptocurrencyMethod: "Выберите метод «Пополнение через криптовалюту»",
  chooseVariantOrContinueEnter: "Выберите вариант или продолжите ввод",
  chooseVerificationMethod: "Выберите способ для отключения подтверждения вывода кодом",
  clear: "Очистить",
  clearFavorites: "Очистить избранное",
  clickCheckoutInHeaderOfSite: "Нажмите «Касса» в шапке сайта",
  clickHome: "Нажмите «На экран Домой»",
  clickOnTheOddsYouLike: "Кликая на понравившиеся коэффициенты, просто совершайте быстрые ставки во всплывающем окне:",
  clickSelectFrontCoin: "Нажмите “Выбрать” напротив монеты, например “Tether TRC20”",
  clickShare: "Нажмите «Поделиться»",
  clickToAttache: "Нажмите, чтобы прикрепить файл",
  clickTopMenuToBuyCrypto: "Нажмите в верхнем меню  “Покупка крипто” и выберите способ оплаты “С банковской карты”. Мин. сумма - 10.40 USD",
  close: "Закрыть",
  code: "Код",
  codeAlreadySendFillIt: "Отправили код подтверждения, введите его в поле ввода",
  codeIsWrong: "Код не верный",
  codeSend: "Смс-код отправлен на номер",
  codeSendToEmail: "Код отправлен на почту",
  codeSendToPhone: "Код отправлен на номер",
  codeSendToTelegram: "Код отправлен через бота в Telegram",
  codeVerificationDisabled: "Подтверждение кодом выключено",
  codeVerificationEnabled: "Подтверждение кодом включено",
  coinSelection: "Выбор монеты",
  comboBoostBonus: {
    button: "Играть",
    content_title: "Как воспользоваться комбобустом:",
    good_luck: "Olymp.casino желает вам крупных выигрышей!",
    range_left_title: "Число событий",
    range_right_title: "Коэф.",
    step_one: "Шаг 1:",
    step_one_description: "Начните собирать свой выигрышный экспресс уже сейчас и обратите внимание, как получить увеличенный коэффициент.",
    step_three: "Шаг 3:",
    step_three_description: "Когда вы сделали свой выбор, совершите ставку! Бонус автоматически увеличит ваш итоговый коэффициент. Вы можете проверить свою ставку в разделе «Мои ставки». Она будет выделена маркером COMBOBOOST.",
    step_two: "Шаг 2:",
    step_two_description: "Продолжайте собирать свой экспресс и наблюдайте за увеличением бонуса.",
    welcoming_range_title: "Узнай свой коэфициент.",
    welcoming_text: "У Olymp.casino есть отличные новости для всех новых клиентов! Чтобы убедиться, что это работает, попробуйте эту возможность сами! Сделайте экспресс-ставку из 2-х или более событий с коэффициентом 1.5 и выше, чтобы увеличить итоговый коэффициент с помощью нашего бонуса. Имейте в виду, чем больше событий в экспрессе, тем больше будет ваш бонус.",
    welcoming_title: "Больше событий в ЭКСПРЕСС - больше Бонус!"
  },
  commission: "Комиссия",
  competitionAction: "Примите участие в турнире, сыграв в одну из указанных игр",
  competitionMembers: "участников турнира",
  competitionParticipants: "Здесь будет отображаться список участников",
  competitionWinners: "Здесь будет отображаться список победителей",
  competitions: "Все турниры",
  competitionsGames: "Турнирные",
  competitors: "{count} участников турнира",
  completeRegistration: "Завершить регистрацию",
  completeSecuritySettings: "Завершите настройку безопасности личных данных и средств",
  completeSignIn: "Завершить авторизацию",
  completed: "Турнир завершен",
  conductError: "Ошибка",
  confirm: "Подтвердить",
  confirmData: "Подтвердить данные",
  confirmInformation: "Подтвердить информацию",
  confirmPersonalData: "Я подтверждаю достоверность персональных данных и понимаю, что данная информация не может быть изменена",
  confirmPhoneNumber: "Подтвердить номер телефона",
  confirmPhoneThroughTelegram: "Зайдите в приложение Telegram и подтвердите номер телефона для безопасного вывода средств",
  confirmationCode: "Код подтверждения",
  confirmationEmail: "Подтверждение email",
  confirmationPhone: "Подтверждение телефона",
  confirmed: "Подтвержден",
  congratulationsTrustWalletCreated: "Поздравляем! Кошелек Trust Wallet создан!",
  contact: "обратитесь",
  continueSecuritySetup: "Вернуться к настройке безопасности",
  converting: "автоматически конвертируются в",
  copeAddressMemo: "Мемо успешно скопирован",
  copeAddressWallet: "Адрес кошелька, успешно скопирован",
  copeAddressWalletNew: "Адрес вашего кошелька успешно скопирован",
  copeCode: "Код успешно скопирован",
  copeSumText: "Сумма успешно скопирована",
  copy: "Скопировать",
  copyAddress: "Скопировать адрес",
  copyCode: "Скопировать код",
  copyTheAddress: "Скопируйте адрес",
  countries: {
    bangladesh: "Бангладеш",
    kazakhstan: "Казахстан",
    kyrgyzstan: "Кыргызстан",
    russia: "Россия",
    uzbekistan: "Узбекистан"
  },
  country: "Выбор страны",
  countryNotFound: "Страна не найдена, проверьте корректность написания",
  countrySelect: "Выбор страны",
  coupon: "Купон",
  couponContainsDependentOutcomes: "В купоне зависимые исходы",
  createWalletInTrustWallet: "Создайте кошелёк в Trust Wallet",
  cryptoMemo: "Мемо",
  cryptoTournament: "Крипто-турнир",
  cryptoWallerSuccessChanged: "Адрес кошелька успешно изменен",
  cryptoWallet: "Криптокошелек",
  cryptocurrency: "Криптовалюта",
  currency: "Валюта",
  current: "Текущие",
  currentBalanceIsLessThanTheWithdrawalAmount: "Доступны не все платежные методы, текущий баланс меньше минимальной суммы для совершения транзакции",
  currentRates: "Текущие ставки",
  customerSupport: "службой поддержки",
  customizeDisplayedCoins: "Для настройки отображаемых монет нажмите на ползунки в правом верхнем углу, на странице добавления токенов в строке поиска введите Doge. Активируйте монету Doge, нажав на ползунок напротив монеты",
  cyrillicInPasswordNotAvailable: "Кириллица в пароле недопустима",
  data: "Дата",
  dataNotSpecified: "Данные не указаны",
  date: "Дата",
  dateFrom: "Дата от",
  dateOfTransaction: "Дата транзакции",
  dateTo: "Дата до",
  deadline: "До окончания осталось",
  december: "декабря",
  decline: "Отклонено",
  demo: "Демо",
  deposit: "Депозит",
  depositAccount: "Пополнить счет",
  depositBK: "Пополнить с БК",
  depositBonus: "{bonus} бонус при пополнении",
  depositForBonus: "Совершите депозит на сумму от {sum}, для получения бонуса",
  depositNoun: "Пополнение",
  depositRequired: "Необходимо совершить депозит от <span class='bonus-item__sum'>{sum}</span>",
  description: "Описание",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Слоты онлайн ➔ играйте на ✓деньги, ✓бесплатно и ✓без регистрации. {company} казино представляет ✓бесплатные ✓популярные ✓современные игровые автоматы, от ✓официальных производителей, с ✓щедрыми бонусами и на ✓разнобразную тематику."
    }
  },
  details: "Подробнее",
  docsWasApproved: "Документы успешно проверены",
  docsWasDeclined: "Документы не прошли проверку",
  documentAttacheMessage: "Мы проверим их в течение 24 часов. После этого, все платежные методы станут для Вас доступны.",
  documentAttacheSuccess: "Ваши документы успешно отправлены.",
  documentDeleteSuccess: "Документы были успешно удалены",
  documentNumber: "Номер документа",
  documentUpload: "Загрузка документов",
  done: "Готово!",
  doneThresholdConditions: "Выполнены условия отыгрыша депозита",
  download: "Скачать",
  downloadApp: "Скачать приложение",
  downloadOlimpApp: "Скачать приложение Олимп",
  download_app: "Скачать приложение Олимп",
  dropswins: {
    eight: "В случайный момент проходят розыгрыши денежных призов на сумму в 9000€. Играй чтобы выиграть!",
    eighteen: "Правила и условия",
    eleven: "Таблица призов еженедельного турнира (обычные недели)",
    fifteen: "Таблица ежедневных призов",
    five: "ЕЖЕДНЕВНО",
    four: "ТУРНИР",
    fourteen: "Таблица призов еженедельного турнира (обычные недели)",
    nine: "4 х 62 000€ еженедельных турнира",
    nineteen: " 1. Это сетевая кампания Pragmatic Play TM. Данная кампания проводится в период с 11.02.2021 по 17.11.2021 CET ( c 01:01 11.02.2021 по 00:59 18.11.2021 EET) <br> 2. Кампания проводится в 10 этапов, где каждый этап длится 4 недели.<br> 3. Общий призовой фонд всей акции составляет 4 000 000 €, который состоит из 40 x 62 000 € еженедельных турниров и 40 x 63 000 € еженедельных розыгрышей призов.<br> 4. Ниже приведены условия 7 этапа данной акции. Обратите внимание, что механика турнира меняется в зависимости от этапа.<br> 5. Чтобы принять участие в любом Турнире или Розыгрыше призов сетевой компании, игроки должны открыть любую из участвующих игр и подтвердить участие / согласиться с условиями.<br> 6. Четыре (4) недели турниров и розыгрышей призов будут проводиться следующим образом:<br> Неделя 27:  11.08.2021 в 20:01 -  18.08.2021 в 19:59 EET<br> Неделя 28:  18.08.2021 в 20:01 -  25.08.2021 в 19:59 EET<br> 7. Квалификационные игры:<br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™\" ",
    one: "Присоединяйся к сетевому турниру Drops & Wins от Pragmatic Play, где каждый может стать победителем!",
    seven: "Поднимись на вершину таблицы лидеров, получив наивысший выигрыш в одиночном вращении.",
    seventeen: "В этом турнире используется механизм, рассчитывающий множитель выигрыша так, чтобы участие в турнире было справедливым для всех игроков, вне зависимости от размера ставки. Например, если ты поставил 2€, а выиграл 10€, то твой множитель выигрыша равен пяти. В этом случае ты получишь пять очков. Поднимись в Топ-1200 лидеров с наивысшим выигрышем в одиночном вращении.",
    six: "Открой игры, в предложении, присоединись к турниру и начинай играть (минимальная ставка 0.50 евро).",
    sixteen: "Для автоматического участия в турнире и розыгрышах призов тебе нужно присоединиться к кампании всего один раз.",
    ten: "4 х 63 000€ еженедельных розыгрыша призов",
    thirteen: "Награда",
    three: "ИГРАЙ",
    twelve: "Место",
    twenty: "Еженедельные турниры",
    twentyfour: "Моментальный кэшбэк",
    twentyone: " 1. Таблица лидеров формируется в соответствии с очками, а очки начисляются на основе наибольшего выигрыша за один спин, полученного в любой участвующей в турнире игре, с учетом суммы ставки.<br> 2. Таблица лидеров обновляется в режиме реального времени, и игроки могут просматривать таблицу лидеров в любое время при игре в любую из участвующих игр турнира.<br> 3. В случае если два (2) или более игроков закончили турнир на одной и той же позиции в таблице лидеров, более высокое место будет отдано игроку, набравшему такое количество очков первым.<br> 4. Призы выплачиваются игрокам в виде фиксированной суммы.<br> 6. Еженедельный призовой фонд включает 1200 денежных призов общую сумму в размере 62 000 €.<br> 7. МЕСТО - ЕЖЕНЕДЕЛЬНЫЕ ПРИЗЫ<br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10 ",
    twentythree: " 1. В течение каждой недели акции проводится семь (7) ежедневных розыгрышей призов.<br> 2. В ходе каждой акции один (1) спин, который соответствует условиям, может принести один (1) приз из призового фонда.<br> 3. Призы разыгрываются на случайной основе. Правила и таблицы призов доступны в участвующих в турнире играх. Таблица призов обновляется в режиме реального времени, показывая текущее положение, а также количество оставшихся призов.<br> 4. Призы выплачиваются, как указано на вкладке \"\"Призы\"\" в каждой из участвующих в турнире игр.<br> 5. Призы выплачиваются игрокам в виде фиксированной суммы.<br> 6. Для участия в розыгрыше призов необходимо сделать минимальную ставку на реальные деньги: 0,50 € в участвующей(-их) в турнире игре(-ах). Один игрок может выиграть несколько призов в течение каждого дня.<br> 7. Розыгрыш призов прекращается ежедневно в (i) 00:59 EEST/EET или (ii) после присуждения всех призов (в зависимости от того, что наступит ранее).<br> 8. Если призовой фонд конкретного ежедневного розыгрыша не будет полностью распределен, то любые излишки средств будут переведены, по усмотрению PragmaticPlay™, в призовой фонд следующего этапа.<br> 9. Еженедельный призовой фонд в общей сложности составляет 63,000 €, а ежедневный призовой фонд включает 500 денежных призов и бесплатных раундов на общую сумму в 9,000 €.<br> 10. Количество - Ежедневные призы<br> 1 X €1,000<br> 2 X €500<br> 5 X €100<br> 12 X €50<br> 110 X €20<br> 370 X €10<br> 11. Победители получают свои призы в денежной форме. Денежные призы будут автоматически зачислены на их игровые счета в казино {baseLink} казино после окончания турнира.<br> 12. {baseLink} оставляет за собой право в любой момент, изменить или отменить условия акции.<br> 13. Действуют общие правила и условия {baseLink}. ",
    twentytwo: "Еженедельные розыгрыши призов",
    two: "Призовой фонд в размере 500 000€ распределен между этапами - 125 000€ в неделю! Чтобы принять участие, просто выполни следующие шаги!"
  },
  email: "Email",
  emailNeedValid: "На почту придет проверочный код",
  emailSuccessfullyApproved: "E-mail успешно подтвержден",
  emptyGames: "Мы не нашли такие игры для вас",
  emptyPromoPage: "Здесь будут отображаться действующие акции",
  ended: "Завершен",
  engineeringWorks: "Через 5 минут на сайте будут проводиться технические работы",
  english: "Английский",
  enter: "Вступить",
  enterCode: "Введите код",
  enterCodeFromEmail: "Введите код из email",
  enterCorrectPhoneNumber: "Введите корректный номер телефона",
  enterCryptoWallet: "Ввести криптокошелёк",
  enterCryptoWalletOnProfilePage: "Введите криптокошелёк Doge в личном кабинете для получения выигрыша",
  enterGameName: "Введите название игры",
  enterGameNameOrProvider: "Введите название игры или провайдера",
  enterMoreCharacters: "Введите больше символов!",
  enterPromoCode: "Введите промокод",
  enterSMS: "Введите код из SMS",
  enterSixDigitCode: "Введите 6-значный код из приложения",
  enterValidEmail: "Введите правильную почту",
  enterWalletAddress: "Укажите сейчас или потом адрес криптокошелька Doge, для начисления выигрыша турнира.",
  enterYourBankCardDetails: "Введите данные банковской карты, согласитесь с условиями платежной системы и нажмите “Оплатить”",
  entrance: "Вход",
  err404subtitle: "Ждём тебя на главной странице!",
  err404title: "Увы, ничего не найдено…",
  error: "Ошибка",
  errorPasswordField: "Пароль должен содержать цифры, заглавные и строчные буквы",
  errorPaymentDataInitialization: "Ошибка при инициализации платежной системы",
  errorPaymentUrlInitialization: "Ошибка при инициализации платежа",
  errorWhileSendingCode: "Отправка сообщения с кодом не удалась, попробуйте запросить его еще раз",
  errorsWhileValidate: "Ошибки при валидации формы",
  euro_slot: {
    description: "Euro Slots 2024 онлайн играть только в {platform} - лучшие официальные игровые слоты. Играй бесплатно и на деньги в онлайн казино.",
    end: "Турнир завершен",
    "final": "Попади в финал",
    inProgress: "Матч идет",
    mathPrize: "Призовой фонд матча:",
    onWallet: "на счет",
    prize: "Общий призовой фонд:",
    "prize-short": "ПРИЗ",
    prizeFond: {
      "1\/2": "Призовой фонд <p>1/2 финала:</p>",
      "1\/4": "Призовой фонд <p>1/4 финала:</p>",
      "1\/8": "Призовой фонд <p>1/8 финала:</p>",
      "final": "Призовой фонд <p>финала:</p>"
    },
    rules: {
      "1": "Акция проводится с 13.06.2024 00-00 GMT +5 по 14.07.2024 00-00 GMT +5",
      "2": "Общий призовой фонд турнира: {sum}",
      "3": "По расписанию проводится битва между слотами, которые двигаются по турнирной сетке",
      "4": "Пользователи, внесшие наибольший вклад в победу той или иной акционной игры, распределяют между собой призовой фонд",
      "5": "Даты для пар стадии 1/8 ({sum}):",
      "6": "Даты для пар стадии 1/4 ({sum}):",
      "7": "Даты для пар стадии 1/2 ({sum}):",
      "8": "Даты финала ({sum}):",
      "9": "Начисление призов происходит автоматически на игровой счет в течение 24 часов"
    },
    stage1: "<span>Регистрируйся</span> и жми кнопку «УЧАСТВОВАТЬ».",
    stage2: "<span>Ставь в любой</span> из участвующих игр и набирай очки.",
    stage3: "<span>Топ игроков</span> разделят общий призовой фонд",
    stages: {
      "1\/2": "1/2 финала",
      "1\/4": "1/4 финала",
      "1\/8": "1/8 финала",
      "final": "финал"
    },
    stagesAtStart: {
      "1\/2": "До начала финала:",
      "1\/4": "До начала 1/2 финала:",
      "1\/8": "До начала 1/4 финала:",
      "final": "Финал",
      pre: "До начала 1/8 финала:"
    },
    start: "Как принять участие",
    table: "Турнирная таблица",
    title: "Турнир Euro Slots 2024 - Играть в слоты онлайн казино {platformSite}",
    winners: "Победители турнира"
  },
  events: "События",
  exchangeRateInTenge: "Курс валюты в тенге",
  exit: "Выход",
  express: "Экспресс",
  expressCoef: "Коэффициент экспресса",
  expressSystem: "Система экспрессов",
  failed: "Действие не выполнено",
  fastBet: "Быстрая ставка",
  fastbetDetailedDescription: "Быстрая ставка позволяет делать одиночные ставки всего в два клика. Запоминание суммы последней сделанной ставки дополнительно ускоряет процесс принятия ставок.",
  fastbetSetting: "Настройки быстрой ставки",
  fastbetSum: "Сумма быстрой ставки",
  favorite: {
    added: "Игра добавлена в избранные",
    removed: "Игра удалена из избранных"
  },
  favorites: "Избранное",
  february: "февраля",
  fieldRequire: "Поле обязательно для заполнения",
  fileAttached: "Файл прикреплен",
  fileNotAttached: "Файл не прикреплён",
  fillInformation: "Заполнить информацию",
  fillProfileInfoForWithdraw: "Пожалуйста, заполните вашу личную информацию, для вывода денег.",
  fillRequiredInfoBelow: "Пожалуйста, заполните необходимую информацию ниже",
  filter: "Фильтр",
  filterByDate: "Фильтр по дате",
  filtersText: {
    inTheNextSixHours: "Ближайшие 6 часов",
    inTheNextTwentyFourHours: "В ближайшие сутки",
    inTheNextTwoHours: "Ближайшие 2 часа",
    nextThreeDays: "В ближайшие 3 суток",
    nextTwelveHours: "Ближайшие 12 часов",
    nextWeek: "В ближайшую неделю",
    today: "Сегодня",
    tomorrow: "Завтра",
    whenever: "За все время"
  },
  findOutAddressOfDogeWallet: "Узнайте адрес кошелька Doge",
  fine: "Хорошо",
  firstAuthMessage: "На номер телефона отправлена СМС с логином и паролем. Пополните счет и отправляйтесь за первыми выигрышами",
  firstDeposit: "На первый депозит!",
  forCorrectGamePushRefresh: "Для корректного отображения игры, нажмите кнопку обновить",
  forEndCompetition: "До окончания турнира",
  forMoreInformation: "За дополнительной информацией",
  forStartCompetition: "До начала турнира",
  forgotPassword: "Забыли пароль?",
  fraud: "AML политика",
  freeBetsButton: "Ознакомиться",
  freeBetsCount: "Доступно фрибетов: ",
  freeBetsStepFour: "Сделайте ставку",
  freeBetsStepOne: "Откройте раздел «Спорт»",
  freeBetsStepThree: "Выберите событие",
  freeBetsStepTwo: "Активируйте «Фрибет» в купоне",
  freeBetsTitle: "«Фрибет» на спорт",
  freeSpinsInGame: "Free Spins в игре",
  freespin: "Фриспин",
  freespinsAvailable: "Доступно фриспинов",
  from: "с {date}",
  fromAnySum: "От любой суммы",
  fromNumber: "от",
  fromSmth: "От {value}",
  fulfillConditionsForWithdrawal: "Выполните все условия для вывода средств.",
  fund: "Призовой фонд",
  future: "Будущие",
  game: "Игра",
  gameDescTemplate: "Игровой автомат {gameName} — онлайн слот от известного разработчика {providerName}. Играйте бесплатно в игровой автомат {gameName} или зарегистрируйтесь, чтобы играть на деньги",
  gameForMoneyOnlyForAuthUser: "Игра на деньги доступна только авторизованным пользователям",
  gameInOtherTab: "Игра открыта в другой вкладке",
  gameNotAvailableBonus: "Игра недоступна из-за условий бонуса",
  gameNotAvailableGeoRestriction: "Игра недоступна в вашем регионе",
  gameNotFound: "Игра не найдена",
  gameTitleTemplate: "Игровой автомат {gameName}. Играть бесплатно в онлайн казино {company}",
  gameUnavailable: "Игра временно недоступна",
  game_categories: "Категории игр",
  games: {
    tryOther: "Попробуйте другие игры"
  },
  gamesNotFound: "Игры не найдены",
  geoRestrictionDesc: "К сожалению, данная игра недоступна в вашем регионе.",
  geoRestrictionDescLine2: "Предлагаем вам выбрать другую игру из каталога",
  get: "Получить",
  getBonus: "Получить бонус",
  getBonusByPromoCode: "Получить бонус по промокоду",
  getGainFromFreeSpins: "Получение выигрыша с фриспинов",
  getNewCode: "Получить новый код",
  getSMS: "Получить SMS код",
  go: "Перейти",
  goBack: "Вернуться назад",
  goToGame: "Перейти к игре",
  goToGames: "Перейти к играм",
  goToHome: "Вернуться на главную",
  goToOlimpCasinoAndPlayFavoriteGames: "Переходите в Olimp Casino и играйте в любимые игры:)",
  goToVolet: "Перейдите на сайт volet.com (advcash)",
  goToWallet: "Перейти к кошельку",
  goesNow: "Идет сейчас",
  gold: "Золото",
  guarantee: {
    five: "Самостоятельный отказ от игры. Если в целях снижения желания играть Вы обратитесь в службу поддержки нашего казино с просьбой заблокировать аккаунт, Ваша просьба будет выполнена. Возможен вариант бесповоротного удаления профиля игрока. В другом случае, по желанию игрока, он может быть восстановлен по истечении некоторого времени.",
    four: "Для игроков, желающих ограничить личный доступ к игре, разработаны следующие варианты:",
    one: "Ответственная игра",
    seven: "Ограничение доступа. Если Вы хотите оградить себя от различных сайтов, предоставляющих или рекламирующих азартные игры, Вам следует использовать специальное программное обеспечение. Оно создает системы фильтрации и обеспечивает безопасное пребывание в интернете пользователей, склонных к игорной зависимости. Кроме этого, программное обеспечение может быть использовано для предотвращения доступа детей к нежелательным ресурсам. Примеры подобного рода софта: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "Специализированная помощь. В случае развития игорной зависимости игроки могут прибегнуть к помощи квалифицированных специалистов. Вам могут помочь: Gamblers Anonymous (www.gamblersanonymous.org.uk) – международное общество анонимных игроков, осуществляющее помощь зависимым игрокам; GamCare (www.gamcare.org.uk) – англоязычная организация, помогающая игрокам избавиться от зависимости; Gambling Therapy (www.gamblingtherapy.org) – организация в Великобритании, предоставляющая квалифицированную поддержку в борьбе с распространенным недугом.",
    three: "Если Вы почувствовали некоторую зависимость от игры, в первую очередь выясните, чем для Вас являются азартные игры. Если игра – это попытка убежать от жизненных сложностей, если она забирает почти все Ваше свободное время и мешает работе, это уже первый звоночек. Если же Вы одалживаете деньги для игры и больше не представляете свой день без нее, это верный показатель того, что Вам необходимы решительные перемены.",
    two: "{titlePure} несет определенную ответственность перед пользователями, играющими на сайте. Администрация казино готова помочь игрокам справиться с возможным возникновением игорной зависимости. Суть игры заключается в том, чтобы доставлять положительные эмоции и давать разрядку. Разумеется, могут случаться и неудачи, но это ни в коем случае не должно вызывать какие-либо финансовые или социальные сложности."
  },
  hasMinimalDeposit: "Внесен минимальный депозит",
  haveActivatedFastbetMode: "Вы активировали режим быстрой ставки. Для ознакомления с правилами, пожалуйста, нажмите",
  haveNotEmailContactUs: "Если вам не пришло письмо на почту, пожалуйста проверьте папку «Спам» и «Промоакции» или свяжитесь со {0}",
  haveNotPhoneContactUs: "Если вам не пришла смс на ваш номер телефона свяжитесь со {0}",
  here: "Здесь",
  hiddenConditions: "Скрытые условия",
  hide: "Скрыть",
  hideBonusCondition: "Скрыть условия бонуса",
  hideDetails: "Скрыть подробности",
  history: "История",
  historyBets: "История ставок",
  historyPayments: "История транзакций",
  historyTransactions: "История транзакций",
  hotGame: "Горячая",
  hotGames: "Горячие игры",
  hotToBuyCryptoCurrency: "Как купить криптовалюту?",
  howCanBuyCryptocurrency: "Как я могу купить криптовалюту?",
  howCreateCryptoWallet: "Как создать криптокошелёк?",
  howCreateWallet: "Как создать кошелёк?",
  howToCreateCryptoWallet: "Как создать криптокошелёк?",
  howToFindOutWalletNumber: "Как узнать номер кошелька?",
  howToInstallApp: "Как установить приложение?",
  howToViewMyCryptoWalletInOlimp: "Как посмотреть мой крипто-кошелёк в Олимпе?",
  howTopUp: "Как пополнить",
  howTransferCrypt: "Как перевести криптовалюту",
  howTransferCryptStep1: "Зайти в кошелёк или биржу",
  howTransferCryptStep2: "Найти выбранную монету {currency}",
  howTransferCryptStep3: "Вставить адрес нашего кошелька",
  howTransferCryptStep4: "Указать и отправить сумму",
  iPaid: "Я пополнил",
  idWasCopied: "Вы скопировали id транзакции",
  inSettings: "в настройках",
  information: "Информация",
  informationConfirmWithdraw: "Подтвердите все свои данные для безопасности и вывода денег. Чтобы изменить адрес электронной почты или номер телефона, свяжитесь с",
  informationConfirmWithdrawSupport: "службой поддержки",
  informationForUpdateProfileData: "Чтобы обновить контактные данные, необходимо обратиться в службу поддержки",
  installApp: "{0} за установку приложения",
  installTrustWalletApp: "Установите приложение Trust Wallet",
  instant: "Быстрые",
  instantCash: "Cashback",
  instantCashback: "Моментальный Cashback",
  instantWithdrawal: "Моментальный вывод",
  instantly: "Мгновенно",
  insufficientFundsAvailable: "Недостаточно средств. Доступно:",
  invalidCryptoWallet: "Неверный адрес кошелька",
  invalidDateFormat: "Неверный формат даты",
  invalidDateInterval: "Выбранный интервал неверный",
  invalidStartDate: "Неверная начальная дата",
  iosWebAppInstruction: "Инструкция iOS",
  jackpot: "Jackpot",
  jackpotGame: "С джекпотом",
  january: "января",
  july: "июля",
  june: "июня",
  kazakh: "Казахский",
  kycPolicy: "KYC политика",
  latestGames: "Недавние игры",
  leftCount: "Осталось {count}",
  leftDeposit: "Осталось пополнить {sum}",
  licenseCuracao: "Содержимое веб-сайта принадлежит и управляется Perantia N.V. (<a href='https://{domain}' target='_blank'>{domain}</a>) в качестве держателя лицензии (лицензия Кюрасао № 365/JAZ). Все права защищены и охраняются законом.",
  lineOn: "Линия на {date}",
  linkIsReady: "Ссылка готова",
  liveCashBackDesc: "{company} предлагает эксклюзивный бонус, который доступен только для наших VIP-клиентов! Делайте ставки в играх из категории “LIVE Казино” и получайте на игровой счет сумму Cashback в зависимости от суммы проигранных ставок!",
  liveCashback: "Live cashback",
  liveCashbackHistory: "История Live cashback",
  live_casino: "LIVE Казино",
  loading: "Загрузка",
  loadingLanguage: "Загрузка языка",
  lobby: "Главная",
  login: "Логин",
  loginCopied: "Ваш логин скопирован",
  loginErr: "Логин {name} не должен содержать буквы!",
  loginTelegram: "Войти с помощью Telegram ",
  logoutFromSystem: "Выход из системы",
  lose: "Поражение",
  losers: "Проигравшие",
  lottery: "Лотерея",
  mainPage: "Главная страница",
  makeABet: "Сделать ставку",
  makeBet: "Сделать ставку",
  makeDeposit: "Внести депозит",
  march: "марта",
  matchClosed: "Матч закрыт",
  matchEnded: "Матч завершен",
  matchNotFound: "Матч не найден",
  matchPlanned: "Матч планируется",
  matches: "Матчи",
  maxBet: "Максимальная ставка",
  maxForExpress: "Максимум для экспресса",
  maxLength: "Максимальная длина поля {length}",
  maxOutput: "Минимальная сумма вывода",
  maxPay: "Максимальная сумма оплаты",
  maxSum: "Макс. сумма",
  maxValue: "Максимальное значение {value}",
  maxValueShort: "Макс: {value}",
  maxWithdrawSum: "Максимальная сумма вывода",
  maximumPayment: "Максимальная сумма оплаты",
  may: "мая",
  messageSMS: "Введите код из смс",
  messages: "Сообщения",
  middleName: "Отчество",
  minBet: "Минимальная ставка",
  minDepositForBonus: "Совершите депозит на сумму не менее {sum}, для завершения шага",
  minLength: "Минимальная длина поля {length}",
  minLengthPassword: "Минимальная длина пароля {min} символов",
  minOutput: "Срок зачисления",
  minPay: "Минимальная сумма оплаты",
  minSum: "Мин. сумма",
  minValue: "Минимальное значение {value}",
  minValueShort: "Мин: {value}",
  minimalDeposit: "Минимальный депозит",
  minimalLengthOfCode: "Минимальная длина кода {num} символов",
  minimalSum: "Минимальная сумма",
  minimumPayment: "Минимальная сумма оплаты",
  minimumTransfer: "Минимальная сумма перевода на счет:",
  modal_telegram: "Активные бонусы и акции, еженедельные розыгрыши и многое другое ты найдешь в нашем канале, а с ботом никогда не потеряешь доступ к сайту!",
  more: "Ещё",
  moveToBonus: "Перейти к бонусу",
  moveToMessages: "Перейти в Сообщения",
  myBalances: "Мои балансы",
  myBonuses: "Мои бонусы",
  name: "Название",
  namePerson: "Имя",
  nameTheCheckout: "Назовите адрес кошелька кассиру",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGames",
    fantasy: "Fantasy",
    fast: "Быстрые",
    jetx: "JetX",
    line: "Линия",
    live: "Live",
    liveGames: "LiveGames37",
    lottery: "Лотерея",
    online: "Live Казино",
    slot: "Слоты",
    sportGames: "Sport games",
    table: "Настольные",
    turboGames: "Turbo games",
    vSport: "V-Sport",
    virtualGames: "Виртуальные",
    worldcup: "ЧМ-2022"
  },
  navLinks: {
    bonuses: "Бонусы",
    home: "Главная",
    homeCasino: "Casino",
    posts: "Сообщения",
    profile: "Профиль",
    promo: "Акции",
    sport: "Спорт",
    tournament: "Турниры"
  },
  needConfirmProfileInformation: "Для активации бонуса подтвердите информацию о себе в профиле",
  needDeposit: "Необходимо сделать депозит",
  needSettingsSecurity: "Необходимо пройти настройки безопасности",
  needToExecuteConditions: "Необходимо выполнить условия",
  never: "Никогда",
  "new": "Новые",
  new2: "Новое",
  newBonusAvailable: "Вам доступен новый бонус",
  newGame: "Новая",
  newMessage: "Новое сообщение",
  newMessages: "Новые сообщения",
  newOne: "Новое",
  newVersionReloadPage: "Версия сайта обновилась, для корректной работы обновите страницу",
  newYearPromocodes2025: {
    NY25DAY1: "50 FS в игре Santa's Gift",
    NY25DAY10: "Фрибет на спорт!",
    NY25DAY11: "50 FS в игре Santa's Great Gifts",
    NY25DAY12: "75 FS в игре Royal Xmass 2",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Santa's Xmas Rush",
    NY25DAY2: "Фрибет на спорт!",
    NY25DAY3: "50% к депозиту и 50 FS в подарок!",
    NY25DAY4: "75 FS в игре Buffalo Power: Christmas",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Royal Xmass",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!"
  },
  next: "Далее",
  nextGames: "Показать еще",
  no: "Нет",
  noAccount: "Нет аккаунта",
  noBetsInHistory: "В Вашей истории нет ставок",
  noConnectionTryAlready: "Нет соединения с интернетом. Подключитесь к Интернету и попробуйте еще раз.",
  noDeposit: "Без депозита",
  noFavoritesYet: "В избранном пока ничего нет",
  noMatchSelected: "Не выбран ни один матч либо нет событий в линии!",
  noResults: {
    bets: "Здесь будут отображаться ваши ставки",
    bonuses: "Здесь будут отображаться доступные бонусы",
    competitions: {
      active: "Здесь будут отображаться активные турниры",
      all: "Здесь будут отображаться все турниры",
      ended: "Здесь будут отображаться прошедшие турниры",
      future: "Здесь будут отображаться будущие турниры"
    },
    gamesNotFound: "Игр не найдено",
    gamesSearch: "Игр по вашему запросу не найдено, попробуйте ввести другой запрос",
    messages: "Здесь будут отображаться ваши сообщения",
    payin: "У вас нет доступных способов пополнения",
    payout: "У вас нет доступных способов вывода",
    simple: "Нет результатов",
    transactions: "Здесь будут отображаться ваши транзакции",
    withdraw: "Здесь будут отображаться ваши заявки на вывод средств"
  },
  noSelectionsForBetting: "Не выбраны исходы для ставки",
  nomination: "Номинация турнира",
  nonBonusGame: "Игра не участвует в бонусной программе. Мы переключим ваш счет на основной.",
  nonBonusGameBetsNotCountInVager: "Игра не участвует в бонусной программе. Ставки не учитываются в вейджере бонуса",
  nonBonusGameWithoutBalance: "Игра не участвует в бонусной программе. Чтобы играть, пополните основной счет.",
  notBonuses: "Сейчас нет доступных бонусов",
  notCompetition: "Сейчас нет активных турниров",
  notConfirmed: "Не подтвержден",
  notDeposit: "Не было пополнений",
  notEnoughEventsForExpress: "Недостаточно  событий для экспресса",
  notEnoughEventsForSystem: "Недостаточно  событий для системы",
  notEnoughMoneyToWithdraw: "Недостаточно денег для вывода",
  notEnoughVventsForSystem: "Недостаточно  событий для системы",
  notInterested: "Не интересно",
  notLogin: "Введите логин {name}!",
  notNow: "Не сейчас",
  notPass: "Введите пароль!",
  notSufficient: "не достаточный",
  notValidValue: "Не правильное значение",
  notification: "Уведомление",
  november: "ноября",
  nowInLine: "Сейчас в линии",
  nowPlayed: "Сейчас отыграно",
  numberErr: "Пожалуйста, проверьте номер указанный при регистрации",
  numberOfWallet: "Номер кошелька",
  october: "октября",
  onAccountBK: "На счету БК",
  oneClick: "Умножай банк в один клик",
  online: "Онлайн",
  onlyForYou: "Только для Вас",
  open: "Открыть",
  openAppTrustWallet: "Откройте приложение и вам будет доступно две функции - зарегистрировать новый кошелёк или восстановить имеющийся. Нажмите нажать на «Создать новый кошелек»",
  openEmail: "Открыть email",
  openGameNewTab: "Для открытия игры нажмите на кнопку",
  openSafari: "Откройте в Safari",
  openSafariIfAnotherBrowser: "Если вы находитесь в каком либо другом браузере, откройте данную страницу в браузере Safari",
  openTelegramBot: "Открыть Телеграм-бот",
  operations: "Операции",
  orders: "Заказы",
  ordinary: "Ординар",
  ordinarySeries: "Серия ординаров",
  other: "Другие",
  otherSections: "Другие разделы",
  ourSocialMedia: "Наши социальные сети",
  ourSocialMediaShort: "Наши соц. сети",
  out: "Выйти",
  output: "Вывод",
  outputModalTitle: "Подтверждение вывода",
  outputSuccess: "Вывод средств успешно завершен!",
  overallCoef: "Общий коэффициент",
  page: "Страница",
  pageErr: "Страница не найдена",
  pageErrDesc: "Страница удалена или адрес введен некорректно",
  pageNotFound: "Cтраница не найдена!",
  pageNotFoundDesc: "Страница удалена или адрес введен некорректно",
  participant: "Участник",
  participate: "Участвовать",
  passErr: "Забыли пароль?",
  passMessage: "Пароль должен содержать цифры, большие и маленькие буквы",
  passportIndex: "Номер паспорта / ID",
  password: "Пароль",
  passwordChanged: "Пароль изменен",
  passwordErr: "Регистрация",
  passwordNew: "Новый пароль",
  passwordSuccess: "Пароль успешно восстановлен",
  passwordTheSame: "Пароль должен отличаться от текущего",
  past: "Прошедшие",
  pay: "Выплата",
  payBonusErr: "Для покупки бонуса, осталось совершить депозит на сумму не менее",
  payMethod: "Способ пополнения",
  payMethods: "Способы пополнения",
  paymentMethod: "Способ оплаты",
  paymentSuccess: "Перевод средств успешно завершен!",
  payoutPayTrxsExistsText: "Для вывода средств необходимо совершить хотя бы одно пополнение",
  payoutThresholdStatusText: "Для вывода средств необходимо отыграть {count}",
  period: "Период",
  personInformationIsApprove: "Данные приняты, аккаунт защищен",
  personalArea: "Личный кабинет",
  personalData: "Личные данные",
  personalDataApproved: "Личные данные подтверждены",
  personalDataIsFilled: "Личные данные заполнены",
  personalDataSuccessfullyEdited: "Ваши персональные данные были успешно изменены",
  phone: "Телефон",
  phoneErr: "Номер телефона не может содержать буквы!",
  phoneNum: "Номер телефона",
  phoneSuccessfullyApproved: "Телефон успешно подтвержден",
  pickUpBonus: "Забрать бонус",
  place: "Место",
  placeAQuickBet: "Сделать быструю ставку?",
  places: "Призовых мест",
  placesCount: "{count} мест",
  placesPrice: "Призовых",
  play: "Играть",
  playAviator: "Играть в авиатор",
  playBonus: "Поздравляем, вы отыграли бонус! Вывод средств будет доступен после пополнения баланса на сумму от {count}",
  playBonusEnded: "Бонус завершен. Для продолжения игры пополните счет на сумму от {count}",
  playForMoney: "Играть на деньги",
  playGamesInCategoryes: "Сыграйте в игры из категорий",
  playWithoutBonus: "Играть без бонуса",
  playingInAppMoreConvenient: "Играть в приложении удобнее",
  pleaseConfirmAgreementToTheTerms: "Пожалуйста, подтвердите согласие с условиями",
  pleaseConfirmInformation: "Пожалуйста, подтвердите информацию",
  pleaseSelectOutcome: "Пожалуйста, выберите исход",
  pleaseUseNumberOfCharacters: "Пожалуйста используйте {num} символов",
  point: "Очки",
  points: "нет очков | {n} очко | {n} очка | {n} очков",
  postSMS: "Отправить смс-код",
  posts: "Сообщения",
  potentialWin: "Потенциальный выигрыш",
  ppenFullBetHistory: "Открыть полную историю ставок",
  preparedForRemoval: "Подготовленно к снятию (в обработке)",
  preview: "Предварительный просмотр",
  prize: "Приз",
  prizes: "Призы победителей",
  proceed: "Продолжить",
  processDeposit: "Обработка пополнения",
  processDepositDescription: "Платеж отправлен и находится в обработке на стороне платежной системы. Срок зачисления средств может составлять от нескольких минут до нескольких дней",
  processWagerFromBonusBalance: "Выполнение вэйджера от бонусного баланса",
  processWagerFromDeposit: "Выполнение вэйджера от суммы депозита",
  processed: "В обработке",
  processing: "В обработке",
  promo: "Акции",
  promoCodeActivationSuccess: "Промокод успешно активирован",
  promoGames: "Бонусные игры",
  promoMaxBetExceeded: "Максимальная сумма ставки, которая пойдет в отыгрыш {bet} {currency}",
  promoNotFound: "Нет действующих акций",
  promocode: {
    activate: "Активировать промокод",
    placeholder: "Промокод",
    title: "Активация промокода"
  },
  promocodes: {
    NY25DAY1: "50 FS в игре Santa's Gift",
    NY25DAY10: "50 FS в игре Santa's Great Gifts",
    NY25DAY11: "Фрибет на спорт!",
    NY25DAY12: "75 FS в игре Royal Xmass 2",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Santa's Xmas Rush",
    NY25DAY2: "50% к депозиту и 50 FS в подарок!",
    NY25DAY3: "Фрибет на спорт!",
    NY25DAY4: "75 FS в игре Buffalo Power: Christmas",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Royal Xmass",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!",
    NYDAY1: "50 FS в игре Hell Hot 100",
    NYDAY10: "50 FS в игре Santa's Great Gifts",
    NYDAY11: "Фрибет на спорт!",
    NYDAY12: "Фрибеты на Aviator",
    NYDAY13: "75% к депозиту и 75 FS в подарок!",
    NYDAY14: "100 FS в игре Sugar Rush Xmas",
    NYDAY2: "50% к депозиту и 50 FS в подарок!",
    NYDAY3: "Фрибет на спорт!",
    NYDAY4: "Фрибеты на JetX",
    NYDAY5: "75% к депозиту и 75 FS в подарок!",
    NYDAY6: "75 FS в игре Twin fruits of Santa",
    NYDAY7: "100% к депозиту и 100 FS в подарок!",
    NYDAY8: "100 FS в игре Sugar Rush Xmas",
    NYDAY9: "50% к депозиту и 50 FS в подарок!"
  },
  promocodes2025: {
    NY25DAY1: "50 FS в игре Santa's Gift",
    NY25DAY10: "Фрибет на спорт!",
    NY25DAY11: "50 FS в игре Santa's Great Gifts",
    NY25DAY12: "75 FS в игре Royal Xmass 2",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Santa's Xmas Rush",
    NY25DAY2: "Фрибет на спорт!",
    NY25DAY3: "50% к депозиту и 50 FS в подарок!",
    NY25DAY4: "75 FS в игре Buffalo Power: Christmas",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Royal Xmass",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!"
  },
  promotionNotFound: "Такой акции не существует",
  protectYouData: "Обезопасьте свои личные данные и средства",
  protection: "Политика конфиденциальности",
  protectionSettingsMessage: "Настройка безопасности аккаунта необходима для сохранения ваших средств и безопасного их вывода",
  providers: "Провайдеры",
  purchaseCryptocurrency: "Покупка криптовалюты",
  putSend: "Получить код",
  queue: "В очереди",
  reSendCode: "Отправить код повторно",
  read: "Прочитано",
  readyForWithdrawOnCashier: "Готово к выплате на кассе",
  receiveWithdrawalConfirmation: "Получить подтверждение вывода средств по электронной почте/Telegram",
  recomend: "Рекомендуем",
  recovery: "Восстановление пароля",
  recoveryEmailDesc: "Чтобы получить доступ к аккаунту, введите email, который вы указали при регистрации",
  recoveryPassword: "Восстановить пароль",
  recoveryPhoneDesc: "Чтобы получить доступ к аккаунту, введите номер телефона, который вы указали при регистрации",
  recoveryWord: "Восстановление",
  refill: "Пополнение счета",
  refresh: "Обновить",
  refreshPage: "Обновить страницу",
  refund: "Возврат",
  refundPolicy: "Политика возврата",
  refundWithdrawal: "Отменить вывод",
  refundWithdrawalModalDesc: "Вы уверены, что хотите отменить вывод средств? При отмене средства вернутся на основной баланс.",
  refundWithdrawalNoun: "Отмена вывода",
  reg: "Регистрация",
  register: "Зарегистрироваться",
  registrationBonus: "Бонус за регистрацию",
  rejected: "Отклонено",
  remainingPlay: "Осталось отыграть",
  repeatPassword: "Повторите пароль",
  repeatTopUpDesc: "Платеж не прошел? Попробуем еще раз?",
  replenishment: "Пополнение",
  requirement: "Требование",
  requisiteDesc: "Для пополнения счета переведите {sum} на счет. Для успешного пополнения, сумма должна полностью совпадать с указанной.",
  resend: "Отправить повторно",
  resendCodeCanAfter: "Отправить повторно код можно через {0}",
  reset: "Сбросить",
  resetFilters: "Сбросить фильтр",
  resetIt: "сбросить его",
  responsibleGame: "Ответственная игра",
  result: "Итог",
  results: "Результаты",
  resultsSearch: "Результаты поиска",
  "return": "Возврат",
  rollback: "Откат",
  rules: "Правила и условия",
  rulesDescription: "Правила",
  rulesShort: "Правила",
  rulesTournament: "Условия и правила турнира",
  russian: "Русский",
  sales: "Продано",
  save: "Сохранить",
  schedule: "Расписание",
  scores: "очков",
  search: "Поиск",
  searchProviders: "Название провайдера",
  seats: "Места",
  secretAnswer: "Ответ на контрольный вопрос",
  secretQuestion: "Контрольный вопрос",
  security: {
    five: "Если у вас остаются вопросы касательно защиты информации, пожалуйста, обратитесь в службу онлайн поддержки либо отправьте письмо по адресу {support}. Мы будем рады помочь вам.",
    one: "Чтобы показать нашу твердую позицию в вопросе ведения бизнеса по мировым стандартам, мы публикуем это положение о защите информации.",
    seven: "Защита информации.",
    six: "Услуги и информация на сайте предоставлены компанией \"Euromirbet d.o.o.\", Podgorica, Cetinjski put bb, reg. no. 5-0685623/1. В соответствии с рекомендациями Payment Card Industry Security Standards Council, для защиты данных покупателя используется шифрование на транспортном уровне — TLS 1.2 и на прикладном уровне алгоритмом AES с длиной ключа 256 бит",
    three: "{titlePure} придерживается анти-спам политики. Все письма, отправляющиеся нашим игрокам относятся к их игровым аккаунтам, а также могут содержать информацию об их новых возможностях в казино и актуальные промо материалы. Частота рекламных рассылок может варьироваться и достигать до 3 писем в сутки. Игроки оставляют за собой право отказаться от рассылки - в таком случае необходимо связаться со службой онлайн поддержки либо отписаться в любое время, кликнув на соответствующую ссылку внизу письма. Информация о ваших выигрышах и совершенных вам выплатах также является строго конфиденциальной и хранится в защищенном окружении.",
    two: "Мы верим, что правильные бизнес отношения строятся только на честности и доверии. Поэтому конфиденциальность вашей информации чрезвычайно важна для нас. Вы можете наслаждаться игрой, зная о том, что мы принимаем все меры по обеспечению сохранности ваших транзакций. Ваше имя, почтовый адрес, e-mail адрес, телефонный номер, дата рождения, пол, IP адрес и прочая информация является приватной и конфиденциальной и не подлежит передаче, продаже и распространению третьим лицам."
  },
  securityAnswer: "Секретный ответ",
  securityQuestion: "Секретный вопрос",
  securitySetting: "Настройка безопасности",
  selectAll: "Выделить все",
  selectApproveMethod: "Выберите способ подтверждения вывода",
  selectCountryToReceive: "Выберите страну, чтобы получать актуальные предложения и условия в регионе",
  selectPaymentCurrencyAndClickTopUpAccount: "Выберите валюту расчета и нажмите «Пополнить счет»",
  selectProviders: "Все игры по выбранным провайдерам",
  selectQuestion: "Сначала выберите вопрос",
  selectVariable: "Выберите подходящий вариант",
  sellBet: "Продать ставку",
  send: "Отправить",
  sendCode: "Отправить код",
  sendCodeError: "Не получается ввести код, обратитесь",
  sendCodeErrorSupport: "в поддержку",
  sendCodeRepeat: "Отправить код еще раз",
  sendCodeSuccess: "Код отправлен на телефон",
  sendCodeSuccessEmail: "Код отправлен на почту",
  sendConfirmationEmail: "Мы отправили email с подтверждением на",
  sendConfirmationPhone: "Мы отправили смс с кодом на номер {phone}",
  sendDocuments: "Отправить документы",
  sendSMS: "Отправить SMS код",
  sendedCodeToEmail: "Отправили код на почту <br> {email}",
  sendedCodeToPhone: "Отправили код на телефон <br> {phone}",
  september: "сентября",
  serverErrorTryAgain: "Ошибка сервера, попробуйте еще раз",
  serverErrorTryRefresh: "Ошибка сервера, попробуйте обновить",
  settlementCurrency: "Валюта расчетов",
  sgtv_bonus: {
    block_one_li_four: "Получите 10 фрибетов.",
    block_one_li_one: "Для получения бонуса необходимо иметь на балансе от {sum} {currency}.",
    block_one_li_three: "Активируйте бонус в Меню.",
    block_one_li_two: "Для активации бонуса перейдите в любую игру провайдера SGTV.",
    block_one_title: "Как получить свой бонус:",
    block_two_li_eight: "Бонус облагается вейджером х20. Минимальный коэффициент при отыгрыше равен 1.5.",
    block_two_li_eleven: "Olymp оставляет за собой право единолично и в любой момент изменить или отменить условия предложения, а также отказать любому игроку без объяснения причин.",
    block_two_li_five: "Новому игроку начисляется 10 фрибетов номиналом {sum} {currency} при входе в раздел Sport Games.",
    block_two_li_four: "Бонус добавляется мгновенно. Если выбранный бонус не был добавлен, необходимо обратиться в службу поддержки до начала игры. Если вы начнете игру без бонуса, он не будет начислен.",
    block_two_li_nine: "Максимальная доступная к выводу сумма выигрыша с бездепозитных фрибетов и бездепозитных бонусов - {sum} {currency}.",
    block_two_li_one: "Пользователь имеет право только на один бонус.",
    block_two_li_seven: "Бонус доступен в течение 3 дней с момента активации.",
    block_two_li_six: "Фрибеты можно использовать в играх «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты».",
    block_two_li_ten: "Фрибеты можно использовать для ставок на коэффициент от 1.3 до 5.",
    block_two_li_three: "Для получения бонуса необходимо сделать пополнение от {sum} {currency}.",
    block_two_li_two: "Бонусы (фрибеты) выдаются игрокам, которые ни разу не совершали ставки в SportgamesTV.",
    block_two_title: "Условия и положения:",
    important_text: "Важно! Если вы начнете игру не активировав бонус, то фрибеты не будет добавлены в последствии.",
    title: "Фрибеты для новых игроков в SportGamesTV! Получите 10 бесплатных ставок в играх «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты»."
  },
  shallWePlay: "Поиграем?",
  shortDescription: "Краткое описание",
  show: "Показать",
  showAll: "Показать все",
  showBets: "Показать ставки",
  showCodeOnlyForOperator: "Не сообщайте код подтверждения никому кроме кассира",
  showGame: "Показать игру",
  showGames: "Показать игры",
  showMatchesStarting: "Показать матчи, начинающиеся:",
  showMoreGames: "Показать больше игр",
  showTerms: "Показать условия",
  showTransactions: "Показать транзакции",
  signUp: "Зарегистрироваться",
  signUpAndVerifyVolet: "Зарегистрируйтесь и пройдите верификацию, которая занимает 15 минут",
  signin: "Войти",
  silver: "Серебро",
  slots: "Слоты",
  smallDescription: "Краткое описание турнира",
  smsCode: "Получить SMS код",
  smsInfo: "На ваш номер будет отправлен SMS код",
  smsSendingDesc: "Введите код, который мы отправили на номер",
  smsVer: "SMS верификация платежей",
  smsVerDisabled: "SMS верификация платежей отключена",
  smsVerEnabled: "SMS верификация платежей включена",
  socialAuthError: "Ошибка авторизации через социальную сеть",
  soonStarted: "Скоро начнется",
  sort: "Сортировать",
  spaceNotAvailableForField: "В этом поле пробелы недопустимы",
  specifyNumberYourPersonalCryptoWallet: "В поле укажите номер вашего личного крипто-кошелька на сайте Olimp.com.",
  spinsBeforeCrediting: "Количество спинов до зачисления:",
  sportErrorText: "Мы сейчас обновляем раздел «Спорт», но уже скоро всё восстановим.",
  sports: "Спорт",
  stakeHasBeenSuccessfully: "Ваша ставка успешно принята!",
  startSecuritySetup: "Пройти настройку безопасности",
  stateOfAnAccount: "Состояние счета",
  status: "Статус",
  statusAcc: "Статус аккаунта:",
  statusOfTransaction: "Статус транзакции",
  statusSuccess: "Подтверждено",
  statuses: {
    calculationInProgress: "Идет расчет",
    inProcess: "В процессе",
    notPayed: "Не выплачено",
    payed: "Выплачено"
  },
  sub_telegram: "Подпишись на телеграм",
  success: "Действие прошло успешно",
  successEnterTournament: "Отлично, Вы в турнире!",
  successPromoCode: "Промокод успешно активирован",
  sufficient: "достаточный",
  sum: "Сумма",
  sumBet: "Сумма ставки",
  sumMoreThanBalance: "Сумма больше чем на балансе",
  sumWithdraw: "Сумма выплаты",
  support: "Поддержка",
  supportContact: "Обратиться в поддержку",
  surname: "Фамилия",
  suspended: "Приостановлен",
  system: "Система",
  table: "Настольные",
  tapOnHome: "Тапните на пункт «На экран Домой», и нажмите «Готово»",
  tapOnShareIcon: "Тапните на иконку «Поделиться» в меню в нижней части экрана. Откроется диалоговое окно",
  term: "Срок зачисления",
  termEnrollment: "Срок зачисления",
  termFulfillment: "Срок на выполнение условий:",
  termsAndConditions: "Условиями и положениями",
  termsAndConditionsList: "Условия и положения",
  timeFulfill: "Время для выполнения условий:",
  timeRemaining: {
    txt: "Осталось {seconds} сек, чтобы получить код еще раз",
    txtPay: "Получить новый код можно будет через {seconds}"
  },
  timeToActivateBonus: "Время на активацию бонуса",
  timer: {
    oneLetter: {
      day: "д",
      hour: "ч",
      minute: "м",
      second: "с"
    },
    "short": {
      day: "дн.",
      hour: "час.",
      minute: "мин.",
      second: "сек."
    }
  },
  tip: "Чаевые",
  titles: {
    cashback: "Cashback",
    dropsWins: "Drops and wins",
    err404: "Запрашиваемой страницы не существует",
    fraud: "Защита от мошенничества",
    gameGroups: {
      "GamesByGroup\/slot": "Слоты онлайн – играть в игровые автоматы на деньги, бесплатно без регистрации"
    },
    home: "{titlePure}",
    profile: "Профиль",
    protection: "Защита информации",
    responsibleGame: "Ответственная игра",
    rules: "Правила и условия",
    tournaments: "Турниры",
    work: "Ведутся технические работы"
  },
  to: "до {date}",
  toFindOutWalletAddressOfCoin: "Чтобы узнать адрес кошелька какой-либо монеты, на основном экране нажмите на монету которую хотите получить, далее отобразится страница монеты с историей транзакций",
  toPromoStart: "До начала акции",
  toSupport: "в службу поддержки",
  topLines: "Топ Линии",
  topUp: "Пополнить",
  topUpWith: "Пополнить с",
  topupYourBalance: "Для игры на деньги, пополните ваш баланс",
  total: "Всего",
  tournament: "Турнир",
  tournamentCryptoReminderText: "Для получения выигрыша не забудьте указать криптокошелёк Doge в личном кабинете ",
  tournamentDescription: "Описание турнира",
  tournamentEnded: "Турнир завершился",
  tournamentGame: "Игра участвует в турнире",
  tournamentGames: "Игры турнира",
  tournamentMounth: {
    "01": "Января",
    "02": "Февраля",
    "03": "Марта",
    "04": "Апреля",
    "05": "Мая",
    "06": "Июня",
    "07": "Июля",
    "08": "Августа",
    "09": "Сентября",
    "10": "Октября",
    "11": "Ноября",
    "12": "Декабря"
  },
  tournaments: "Турниры",
  transactionCopied: "Вы скопировали id транзакции",
  transactionSuccess: "Транзакция успешно завершена",
  transactionsIsNotExist: "У вас пока не было транзакций",
  transactionsNotFound: "Транзакций по выбранным фильтрам не найдено. Попробуйте отредактировать параметры фильтра или {0}",
  transfer: "Перевести",
  transferAccount: "Перевести на счет",
  transferAmount: "Введите сумму перевода",
  transferAmount2: "Введите сумму перевода",
  transferSuccessfully: "Перевод средств успешно завершен!",
  transferTheMoneyAndWait: "Передайте деньги кассиру и ожидайте пополнения",
  transitionDate: "Дата транзакции",
  transitionStatus: "Статус транзакции",
  transitionType: "Тип транзакции",
  turnOff: "Выключить",
  turnOn: "Включить",
  turnOnState: "Включено",
  turnover: "Оборот",
  twoFactorAuth: "Двухфакторная аутентификация",
  typeOfTransaction: "Тип транзакции",
  uncalculated: "Нерассчитанные",
  underCoinBalanceClickGetButton: "Под балансом монеты нажимаем кнопку «Получить».  Далее необходимо скопировать адрес при помощи кнопки или использовать штрихкод для сканирования",
  unexpectedErrorWriteToSupport: "Произошла непредвиденная ошибка, но мы уже скоро все поправим.",
  unexpected_error_try_again: "Непредвиденная ошибка, попробуйте еще раз",
  unhandledErrorTryToRefreshPage: "Неожиданная ошибка, попробуйте обновить страницу",
  unselect: "Снять выделение",
  untilStartLeft: "До начала осталось",
  update: "Обновить",
  upload: "Загрузить",
  uzbek: "Узбекский",
  verification: "Верификация",
  verificationDeclined: "Верификация отклонена. Пожалуйста, свяжитесь со службой поддержки.",
  verificationDeclinedInfo: "Документы не прошли проверку. Пожалуйста, прикрепите документы повторно или свяжитесь со службой поддержки.",
  verificationInProgress: "Верификация выполняется. Пожалуйста, подождите.",
  verificationsSMSDesc: "Для верификации платежей, подтвердите номер телефона, который вы указали при регистрации",
  verifyYourAccount: "Верифицируй свой аккаунт",
  virtuals: "В-Спорт",
  wager: "Вейджер",
  wagerGame: {
    accessAfterRolePlay: "Игра будет доступна после окончания отыгрыша бонуса",
    gamesWagering: "Игры в которых доступен отыгрыш",
    nowPlayed: "Сейчас отыграно",
    remainForPlay: "Осталось отыграть"
  },
  wallet: "Кошелек",
  walletCopied: "Кошелек скопирован",
  walletId: "Адрес кошелька",
  walletNotLinked: "Кошелек не привязан",
  way: "Способ вывода",
  ways: "Способ вывода",
  wbCashboxActiveText: "Для получения 100% за депозит на бонусный счет, пополните счет от {minSum}. Основной счет будет доступен после отыгрыша бонуса.",
  wbCashboxNotActiveText: "Для получения 100% за депозит на бонусный счёт активируйте бонус в личном кабинете.",
  wbWaitOnProfile: "Приветственный бонус ждет вас в разделе «Бонусы» в личном кабинете",
  welcomeBonus: "Welcome бонус",
  welcomeBonusCasino: "Welcome бонус казино",
  welcomeBonusDescription: "Успейте внести оплату в течение часа и получите увеличенный бонус <span class='text-accent'>125%</span> за депозит и до 250 фриспинов!",
  welcomeBonusSport: "Welcome бонус спорт",
  welcomeBonusTitle: "+25% к Welcome бонусу",
  win: "Победа",
  winnerPoints: "Очки победителей",
  winners: "Выигравшие",
  withAnIncrease: "При повышении",
  withDrawOrdered: "Вывод оформлен",
  withDrawOrderedDesc: "В ближайшее время средства будут зачислены на ваш указанный счет.",
  withInstantCashback: "С моментальным кэшбэком",
  withdraw: "Вывести",
  withdraw2: "Вывести на",
  withdrawBK: "Вывести на БК",
  withdrawFunds: "Вывод средств",
  withdrawMethod: "Способ вывода",
  withdrawMethods: "Способы вывода",
  withdrawNoun: "Вывод",
  withdrawPaymentInfo: "Снятие средств методом Visa/Mastercard доступно только на привязанные к логину карты. Для привязки Вам необходимо пополнить Ваш логин методом Visa/Mastercard.",
  withdrawPerDayCountExceeded: "Вы можете сделать до 1 вывода каждый день",
  withdrawTelegramBot: "Для вывода средств необходимо запустить Телеграм-бот и авторизоваться в нем",
  withdrawWithApprove: "Вывод средств с подтверждением кода",
  withdrawWithCode: "Вывод средств с подтверждением кодом",
  withdrawal: "Ограничения на вывод средств",
  withdrawalCompletedSuccessfully: "Заказ на вывод сформирован",
  withdrawalOfFunds: "Вывод средств с подтверждением кодом",
  work: "Ведутся технические работы",
  writeToSupport: "Написать в поддержку",
  yes: "Да",
  yesConfirm: "Да, уверен",
  yesOfCourseIWant: "Да, конечно хочу",
  yesRefundWithdrawal: "Да, отменить вывод",
  yesSure: "Да, пополнил",
  you: "Вы",
  youAreAuthorized: "Вы авторизованы",
  youAreParticipateInTheTournament: "Вы участвуете в турнире!",
  youDontHaveTransactions: "У вас пока не было транзакций",
  youHaveNewMessage: "У вас новое сообщение",
  youHaveNotNewMessages: "У вас нет новых сообщений",
  youHaveSmsVerification: "У вас включена верификация платежей, для совершения перевода, пройдите проверку по SMS",
  youTakePart: "Вы участвуете",
  yourBalance: "Ваш баланс",
  yourCasinoBonus: "Ваш бонус в казино",
  yourCurrentEmail: "Ваш e-mail сейчас",
  yourCurrentPhone: "Ваш номер сейчас",
  yourEmail: "Ваш email",
  yourPersonalUniqueWalletIsDisplayedHere: "Здесь отображен ваш личный уникальный кошелек для той монеты, которую вы выбрали ранее. Для копирования адреса кошелька можно использовать специальную кнопку или QR код."
} 
